/* eslint-disable no-useless-escape */
const ENV = {
  PROD: 'production',
  DEV: 'development',
};
const DEFAULT_QUERY_PARAMS = { shop: 'dev' };
const domain = process.env.REACT_APP_THINKIFIC_ENDPOINT;

const emailRegex =
  /^(([^<>()\[\]\\.,;:^&*#%~!$\s@"]+(\.[^<>()\[\]\\.,;:^&*#%~!$\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const passwordRegex = /^.{6,}$/;
const domainRegex = new RegExp(`^([a-zA-Z0-9_-]+)\.${domain}$`);

export { domainRegex, emailRegex, passwordRegex, DEFAULT_QUERY_PARAMS };

export default ENV;
